import React from 'react'
import { useNavigate } from 'react-router-dom'

function Home() {
  const navigate = useNavigate('')
  console.log(localStorage.getItem("login"))
  setTimeout(() => {
    
    if(localStorage.getItem("login") == "true"){
      navigate("/user")
    }
    else{
      navigate("/")
    }
  }, 500);
  return (
    <div>Please wait. You will be redirected soon...</div>
  )
}

export default Home